const apiConstents = {
    partnerCropConects:'populate=crop_connects,tenePartnerUsers,tenePartnerUsers.tene_partner_user_info,tenePartnerUsers.tene_partner_user_info.crop_edit_rights,tenePartnerUsers.tene_partner_user_info.tene_partner_roles',
    dateTimeFormat:'DD/MM/YYYY HH:mm:ss',
    dateTimeFormat1:'DD/MM/YYYY',
    dateTimeFormat2:"MMMM, DD",
    cropCyclesPopulate:'populate=crop_connect,packages,packages.package_time_lines,packages.package_time_lines.package_practices',
    cropCyclesPageSize:'&pagination[pageSize]=',
    allDataLimit:'pagination[limit]=-1',
    fileterUser:'&filters[partner][id][$contains]=',
    fileterUser2:'&filters[partner][id][$eq]=',
    fileterUser3:'&filters[AND][crop_connect][in]=',
    editRoleManager:'Content_Manager',
    editRoleExpert : 'Content_Expert'

}
export default apiConstents;